<!-- Modal -->
<template>
    <div class="modal fade" id="createOrUpdateUserModal" ref="createOrUpdateUserModal" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="saveUser">
						<div class="modal-header">
							<div>
								<h5 class="modal-title" id="exampleModalLabel">{{ update ? 'Update User' : 'New User' }}</h5>
								<small class="text-muted">Default role is editor.</small>
							</div>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="form-group mb-3">
								<label for="name">Name</label>
								<input type="text" v-model="user.name" placeholder="Enter name" class="form-control" required />
							</div>
							<div class="form-group mb-3">
								<label for="email">Email</label>
								<input type="email" v-model="user.email" @input="setUsername()" placeholder="Enter email" class="form-control" required />
							</div>
							<div class="form-group mb-3 d-none">
								<label for="username">Username </label>
								<input type="text" v-model="user.username" placeholder="Enter username" class="form-control" autocomplete="username" />
							</div>
							<div class="form-group mb-3">
								<label>Password</label>
								<div class="ju-input-affix">
									<input
										:type="showPassword ? 'text' : 'password'"
										v-model="user.password"
										placeholder="Enter password"
										class="form-control"
										autocomplete="new-password"
										:required="update ? null : true"
									/>
									<div class="ju-input-affix__actions">
										<button
											type="button"
											class="ju-input-icon-btn"
											@click="showPassword = !showPassword"
											:title="showPassword ? 'Hide password' : 'Show password'"
										>
											<font-awesome-icon :icon="['fas', showPassword ? 'eye-slash' : 'eye']" />
										</button>
										<span class="ju-input-affix__sep"></span>
										<button
											type="button"
											class="ju-input-affix__btn"
											@click="generatePassword()"
											title="Generate a strong password and fill both fields"
										>
											generate
										</button>
									</div>
								</div>
							</div>
							<div class="form-group mb-3">
								<label>Password confirm</label>
								<input
									:type="showPassword ? 'text' : 'password'"
									v-model="user.password_confirmation"
									placeholder="Confirm password"
									class="form-control"
									autocomplete="new-password"
									:required="update ? null : true"
								/>
							</div>

                            <div class="juniper-role-box">
                                <div class="ju-roles-title">Roles</div>
                                <div class="ju-roles-grid">
                                    <label v-for="role in roles" :key="role.id" class="ju-role" :for="`roleSwitch${role.id}`">
                                        <input class="ju-switch-input" type="checkbox" :id="`roleSwitch${role.id}`" v-model="userRoles" :value="role.name">
                                        <span class="ju-switch"></span>
                                        <span class="ju-role__label">{{ role.name }}</span>
                                    </label>
                                </div>
                            </div>
						</div>
						<div class="modal-footer">
							<button type="button" class="ju-modal-btn ju-modal-btn--muted" data-bs-dismiss="modal">Close</button>
							<button type="submit" class="ju-modal-btn ju-modal-btn--primary">Save</button>
						</div>
					</form>
				</div>
			</div>
		</div>
</template>
<script>

import { Modal } from "bootstrap";
import juniperApi from '@/api/juniperApi'

export default {
    name: "CreateOrUpdateUserModal",
    components: {
    },
    emits: ["userSaved", "createOrUpdateUserModalClosed"],
    data: () => ({
        modal: null,
        inProgress: false,
        showPassword: false,
        roles: [],
        userRoles: [],
        user: {
            email: '',
            username: '',
            password: '',
            password_confirmation: '',
        },
    }),
    mounted() {
        this.modal = new Modal(this.$refs.createOrUpdateUserModal);
        // this.showToast()

        this.setRoles();
        
        let createOrUpdateUserModal = document.getElementById("createOrUpdateUserModal");
        
        let self = this;
        
        createOrUpdateUserModal.addEventListener("hidden.bs.modal", function () {

            self.$emit("createOrUpdateUserModalClosed");
            
            self.user = {
                email: '',
				username: '',
				password: '',
				password_confirmation: ''
			};
            self.showPassword = false;
        });
    },
    watch: {
        userForChildComponent (user) {
            this.user = user;
            this.userRoles = (this.user.roles && this.user.roles.length) ? this.user.roles.map(role => role.name) : [];
        },
    },
    methods: {
        showModal: async function (value) {
            if (value) {
                this.modal.show();
                this.user = this.userForChildComponent;
            }
        },
        // Save User
		async saveUser () {

            this.user.roles = this.userRoles;

            try {
                
                if (this.update) {
                    // await juniperApi.put(`/users/${this.user.id}?client_id=${this.$route.params.id}`, this.user);
                    await juniperApi.put(`/users/${this.user.id}${this.$route.params.id ? '?client_id=' + this.$route.params.id : '' }`, this.user);
                } else {
                    await juniperApi.post(`/users${this.$route.params.id ? '?client_id=' + this.$route.params.id : '' }`, this.user);
                }

                this.$swal.fire({
                    icon: 'success',
                    title: 'Users saved successfully!',
                    timer: 4000,
                })

                this.modal.hide();
                this.$emit("userSaved");

            } catch (error) {
                    let message = ''
                if (error.response.data.error) {
                    for (const [key, value] of Object.entries(error.response.data.error)) {
                        console.log(key)
                        message += ` ${value} \n`
                    }
                }
                this.$swal.fire({
                    icon: 'error',
                    title: message,
                    timer: 6000,
                })
            }
		},
        generatePassword() {
			let password = ''
			let characters = 'abcdefghijklmnopqrstuvwxyz'
			characters += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
			characters += '0123456789'
			characters += '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~'
			for (let i = 0; i < 15; i++) {
				password += characters.charAt(Math.floor(Math.random() * characters.length))
			}
			// Fill both password fields and reveal so the value is visible/copyable.
			this.user.password = password
			this.user.password_confirmation = password
			this.showPassword = true
		},
        setUsername() {
			this.user.username = this.user.email
		},
        async setRoles() {
            const res = await juniperApi.get('/roles');
            this.roles = res.data;
        }
    },
    computed: {
        
    },
    props: {
        update: Boolean,
        userForChildComponent: Object
    },
};
</script>
<style scoped>
    .modal-content {
        border: 1px solid #e6e8ec;
        border-radius: 12px;
        box-shadow: none;
    }

    .modal-header,
    .modal-footer {
        border-color: #f0f1f4;
    }

    .modal-title {
        font-size: 1rem;
        font-weight: 600;
        color: #111827;
    }

    /* Inputs — settings language */
    .modal-body .form-control {
        border: 1px solid #e6e8ec;
        border-radius: 8px;
        font-size: 0.9rem;
        padding: 0.45rem 0.7rem;
        box-shadow: none;
    }

    .modal-body .form-control:focus {
        border-color: #2b6cff;
        box-shadow: 0 0 0 3px rgba(43, 108, 255, 0.15);
    }

    .form-group label {
        font-size: 0.8rem;
        font-weight: 600;
        color: #374151;
        margin-bottom: 0.25rem;
    }

    /* Password field with inline actions (show/hide + generate) */
    .ju-input-affix {
        position: relative;
    }

    .ju-input-affix .form-control {
        padding-right: 108px;
    }

    .ju-input-affix__actions {
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        gap: 2px;
    }

    .ju-input-affix__sep {
        width: 1px;
        height: 18px;
        background: #e6e8ec;
        margin: 0 2px;
    }

    .ju-input-icon-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        border: none;
        background: none;
        color: #8a909c;
        border-radius: 6px;
        cursor: pointer;
        font-size: 13px;
        transition: color 0.15s ease, background 0.15s ease;
    }

    .ju-input-icon-btn:hover {
        color: #2b303b;
        background: #f3f5f9;
    }

    .ju-input-affix__btn {
        border: none;
        background: none;
        color: #2b6cff;
        font-size: 0.78rem;
        font-weight: 600;
        padding: 4px 6px;
        border-radius: 6px;
        cursor: pointer;
        transition: background 0.15s ease, color 0.15s ease;
    }

    .ju-input-affix__btn:hover {
        background: #eef3ff;
    }

    /* Roles — minimalistic card + custom neutral toggles */
    .juniper-role-box {
        border: 1px solid #e6e8ec;
        border-radius: 10px;
        background: #f9fafb;
        padding: 1rem 1.15rem;
        margin: 1.25rem 0;
    }

    .ju-roles-title {
        font-size: 0.8rem;
        font-weight: 600;
        color: #6c757d;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        margin-bottom: 0.75rem;
    }

    .ju-roles-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
        gap: 12px 18px;
    }

    .ju-role {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        margin: 0;
        cursor: pointer;
        font-size: 0.88rem;
        color: #374151;
    }

    .ju-switch-input {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
    }

    .ju-switch {
        position: relative;
        flex: 0 0 auto;
        width: 34px;
        height: 20px;
        border-radius: 999px;
        background: #d1d5db;
        transition: background 0.15s ease;
    }

    .ju-switch::after {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #fff;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        transition: left 0.15s ease;
    }

    .ju-switch-input:checked + .ju-switch {
        background: #111827;
    }

    .ju-switch-input:checked + .ju-switch::after {
        left: 16px;
    }

    .ju-switch-input:focus-visible + .ju-switch {
        box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.15);
    }

    .ju-role__label {
        line-height: 1.2;
    }

    /* Footer buttons — flat settings buttons */
    .ju-modal-btn {
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.35rem 0.85rem;
        font-size: 0.85rem;
        font-weight: 600;
        border-radius: 8px;
        border: 1px solid #e6e8ec;
        background: transparent;
        color: #111827;
        cursor: pointer;
        transition: background 0.15s ease, border-color 0.15s ease;
    }

    .ju-modal-btn:hover {
        background: #f3f5f9;
    }

    .ju-modal-btn--muted {
        color: #6b7280;
    }

    .ju-modal-btn--primary {
        border-color: #111827;
    }
</style>
